'use client';

import { Box, Divider, useMediaQuery, useTheme } from '@mui/material';
import { CdMarketplaceEntityType } from '@repo/supergraph/marketplace/bankingCdOffersMarketplaceSearch/types';
import { formatLabel } from '@repo/utils/cdTerm/formatLabel';
import { getDriverRange, getMinMinimumBalance } from '../utils';
import { Driver } from './Driver';

type Props = {
  cdOffers: CdMarketplaceEntityType[];
};

export const Drivers = ({ cdOffers }: Props) => {
  if (!cdOffers || cdOffers.length === 0) {
    return null;
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const apyDriver = getDriverRange(cdOffers, 'apy', offer => offer.driverApy?.value);
  const cdDepositTermDriver = getDriverRange(cdOffers, 'cdDepositTerm', offer =>
    formatLabel({ cdDepositTerm: offer.cdDepositTerm }),
  );
  const minimumBalanceDriver = getMinMinimumBalance(cdOffers);

  return (
    <Box
      sx={{
        display: 'flex',
        borderTopWidth: 1,
        borderTopColor: 'neutral.lighter',
        borderTopStyle: { sm: 'solid' },
        height: '100%',
        justifyContent: 'space-evenly',
        flexDirection: { xs: 'column', sm: 'row' },
      }}
    >
      <Driver driverLabel="Annual percentage yield" driverValue={apyDriver} />
      <Divider orientation={isMobile ? 'horizontal' : 'vertical'} />
      <Driver driverLabel="Min. Deposit to open" driverValue={minimumBalanceDriver} />
      <Divider orientation={isMobile ? 'horizontal' : 'vertical'} />
      <Driver driverLabel="Term" driverValue={cdDepositTermDriver} />
    </Box>
  );
};
